function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.411,
    y1: 0.0000436869,
    x2: 0.5927,
    y2: 0.0000436869,
    gradientTransform: "matrix(95.123095,-96.784637,96.784637,95.123095,-34.277639,62.103726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.745098%,0.392157%,20.784314%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(38.039216%,17.647059%,31.372549%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 6.859375 3.644531 L 20.140625 3.644531 C 21.890625 3.644531 23.3125 5.066406 23.3125 6.816406 L 23.3125 20.183594 C 23.3125 21.933594 21.890625 23.355469 20.140625 23.355469 L 6.859375 23.355469 C 5.109375 23.355469 3.6875 21.933594 3.6875 20.183594 L 3.6875 6.816406 C 3.6875 5.066406 5.101562 3.644531 6.859375 3.644531 Z M 6.859375 3.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.644531 12.128906 C 14.148438 12.128906 14.527344 12.019531 14.785156 11.796875 C 15.042969 11.582031 15.171875 11.257812 15.171875 10.832031 C 15.171875 10.410156 15.042969 10.09375 14.785156 9.875 C 14.527344 9.65625 14.148438 9.542969 13.644531 9.542969 L 11.886719 9.542969 L 11.886719 12.128906 L 13.644531 12.128906 M 13.753906 17.46875 C 14.390625 17.46875 14.871094 17.335938 15.191406 17.070312 C 15.511719 16.804688 15.675781 16.398438 15.675781 15.859375 C 15.675781 15.332031 15.511719 14.9375 15.195312 14.671875 C 14.875 14.40625 14.398438 14.273438 13.75 14.273438 L 11.878906 14.273438 L 11.878906 17.46875 L 13.753906 17.46875 M 16.710938 13.078125 C 17.394531 13.273438 17.921875 13.632812 18.300781 14.164062 C 18.671875 14.695312 18.863281 15.339844 18.863281 16.109375 C 18.863281 17.285156 18.460938 18.164062 17.65625 18.742188 C 16.851562 19.320312 15.632812 19.613281 13.992188 19.613281 L 8.710938 19.613281 L 8.710938 7.402344 L 13.484375 7.402344 C 15.195312 7.402344 16.4375 7.65625 17.203125 8.167969 C 17.976562 8.683594 18.359375 9.503906 18.359375 10.632812 C 18.359375 11.226562 18.21875 11.734375 17.9375 12.15625 C 17.65625 12.570312 17.246094 12.878906 16.710938 13.078125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostrap);
export default __webpack_public_path__ + "static/media/boostrap.63396ce716f927da4ab63df6edf4fd80.svg";
export { ForwardRef as ReactComponent };